import config from '../config';
import category from './routes-category';

export const TEACHER_ROUTES = {
  DEFAULT: '/dashboard',
  routes: [
    {
      category: category.teacher.AIT,
      path: '/dashboard',
      component: () => import('@/features/dashboard/DashboardPage'),
      config: config.teacher,
      title: 'Dashboard',
    },
    {
      category: category.teacher.AIT,
      path: '/planner',
      component: () => import('@/features/planner/PlannerPageContainer'),
      config: config.teacher,
      title: 'Weekly Planner',
    },
    {
      category: category.teacher.AIT,
      path: '/settings',
      component: () => import('@/features/settings/pages/SettingsPageWrapper'),
      config: config.teacher,
      title: 'Settings',
    },
    {
      category: category.teacher.AIT,
      path: '/planner/lesson',
      component: () => import('@/features/planner/LessonDetailPage'),
      config: config.teacher,
      title: 'Lesson Detail',
    },
    {
      category: category.teacher.AIT,
      path: '/planner/student-learning-playlist',
      component: () => import('@/features/planner/StudentLearningPlaylistPage'),
      config: config.teacher,
      title: 'Student Learning Playlist',
    },
    {
      category: category.teacher.ACTIVITIES,
      path: '/teacher/gradebook/activities',
      component: () => import('@/components/Teacher/StudentSearch'),
      config: config.studentSearch,
      title: 'Activities',
    },
    {
      category: category.teacher.REPORTS,
      path: '/teacher/reports/type/:report',
      component: () => import('@/components/Reports'),
      config: config.teacher,
      exact: true,
    },
    {
      category: category.teacher.REPORTS,
      path: '/teacher/reports',
      component: () => import('@/components/Reports'),
      config: config.teacher,
      exact: true,
      title: 'Reports',
    },
    {
      //category: category.teacher.GRADEBOOK, TODO: Add the relevant Category when we have an Intent for this route
      path: '/teacher/gradebook/scoring/:activityId',
      component: () => import('@/components/Teacher/CorrectionManager'),
      config: config.teacher,
      //TODO: Implement matchRouteWithSlots
      //matchRouteWithSlots: function({activityId='1F8783C4D2ED11E89543168CA1AFEB4A'}){
        //activityId variable should match the name of the property sent from chatBot under slots
        //Inserting some dummy data as default to be safe
        //return this.path.replace(':activityId', activityId);
      //},
    },
    {
      //category: category.teacher.GRADEBOOK, TODO: Add the relevant Category when we have an Intent for this route
      path: '/teacher/gradebook/comprehension',
      component: () => import('@/components/Teacher/ComprehensionReportCard/ComprehensionReportCard'), //ComprehensionReportCard,
      config: config.teacher,
    },
    {
      category: category.teacher.DIAGNOSTIC,
      path: '/teacher/resources',
      component: () => import('@/components/Teacher/Resources'),
      config: config.teacher,
      exact: true,
      title: 'Resources',
    },
    {
      category: category.teacher.ADMIN,
      path: '/admin/school',
      component: () => import('@/components/Teacher/Admin/containers/SchoolResults'),
      config: config.teacher,
      exact: true,
      type: 'schoolResults',
      label: 'SCHOOL-WIDE RESULTS',
      subtext: 'Export school-wide test results',
      tagline: 'CSV-format data on all students',
      link: '/admin/school',
      title: 'School-wide Results',
    },
    {
      category: category.teacher.ADMIN,
      path: '/admin/dashboard/:itemId',
      component: () => import('@/components/Teacher/Admin/containers/AdminDashboard'),
      config: config.teacher,
      type: 'adminDashboard',
      label: 'ADMIN DASHBOARD',
      title: 'Admin Dashboard',
      subtext: 'View aggregate data for your district or school',
      tagline: ' ',
      link: '/admin/dashboard/tracking',
      subdistrict: true,
    },
    {
      category: category.teacher.ADMIN,
      path: '/admin',
      component: () => import('@/components/Teacher/Admin/AdminPortal'), //AdminPortal,
      config: config.teacher,
      exact: true,
      title: 'Admin Portal',
    },
    {
      category: category.teacher.AIT,
      path: '/planner/rollover',
      component: () => import('@/features/planner/RolloverPage'),
      config: config.teacher,
      title: 'Rollover Plan',
    },
    /*
    {
      category: category.teacher.REPORTS,
      path: '/teacher/reports/:reportType/:reportId',
      component: ReportingPortal,
      config: config.teacher,
      matchRouteWithSlots: function({reportType='benchmark', reportId='12345'}){
        //reportType and reportId variables should match the name of the properties sent from chatBot under slots
        //Inserting some dummy data as default to be safe
        return this.path.replace(':reportType', reportType).replace(':reportId', reportId);
      },
    },
    */
  ]
};

export default TEACHER_ROUTES;